import { render, staticRenderFns } from "./BasePhone.vue?vue&type=template&id=538bad0a&scoped=true&"
import script from "./BasePhone.vue?vue&type=script&lang=js&"
export * from "./BasePhone.vue?vue&type=script&lang=js&"
import style0 from "./BasePhone.vue?vue&type=style&index=0&id=538bad0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538bad0a",
  null
  
)

export default component.exports